import { apiCall, baseUrl, extendUrl } from './config';
import { parseQueryParams } from '../../utils/queryParams';
import { shouldUseMock } from '../../utils/common';
import {
  favoriteNodeActionMock,
  getCategoriesMock,
  getAcademyDetailMock,
  getAcademyMock,
  setCommentsMock,
} from './mock';

export default {
  getAcademyList: (filters = {}) => {
    if (shouldUseMock()) return getAcademyMock();
    const url = `${baseUrl}${extendUrl}user/course${parseQueryParams(filters)}`;
    console.log('[API][academy] GET', url);
    return apiCall(url, 'GET');
  },

  getAcademyDetails: ({ id, ...filters }) => {
    if (shouldUseMock()) return getAcademyDetailMock();
    const url = `${baseUrl}${extendUrl}user/course/${id}/details${parseQueryParams(filters)}`;
    console.log('[API][academy] GET', url);
    return apiCall(url, 'GET');
  },

  setNodeAction: (payload) => {
    if (shouldUseMock()) return favoriteNodeActionMock();
    const url = `${baseUrl}${extendUrl}user/node_action`;
    console.log('[API][academy] POST', url, payload);
    return apiCall(url, 'POST', payload);
  },

  setComment: (body) => {
    if (shouldUseMock()) return setCommentsMock();
    console.log('[API][academy] POST /comment', body);
    return apiCall('/comment', 'POST', body);
  },

  getCategories: (filters = {}) => {
    if (shouldUseMock()) return getCategoriesMock();
    const url = `${baseUrl}${extendUrl}vocabulary${parseQueryParams(filters)}`;
    console.log('[API][academy] GET', url);
    return apiCall(url, 'GET');
  },
};
